import { combineReducers } from "redux"
import disbursement from "./disbursements"

const disbursementReducer = combineReducers({
  disbursement,
})

export default disbursementReducer
